module.exports = __webpack_public_path__ + "img/bz.ec7cadfe.svg";